var map = {
	"./add.svg": 1105,
	"./back.png": 6686,
	"./back2.png": 7038,
	"./copy.svg": 8375,
	"./favicon.ico": 129,
	"./filters.svg": 6081,
	"./login_bg.png": 5628,
	"./logo.svg": 5429,
	"./logo_old.svg": 8631,
	"./mail_title.png": 1573,
	"./minicolors.png": 1786,
	"./profile_avatar.svg": 9213,
	"./remove.svg": 6776,
	"./selected.svg": 2051,
	"./user.svg": 6449,
	"./user_hover.svg": 8690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;